/* eslint-disable camelcase */
import React, { useState } from "react"
import { Paper, Typography, Box, Button, Divider } from "@mui/material"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline"
import FactCheckIcon from "@mui/icons-material/FactCheck"
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome"
import DoneAllIcon from "@mui/icons-material/DoneAll"
import Swal from "sweetalert2"

import ModalTareaBasica from "./ModalTareaBasica"
import { api, showSuccess, showWarning } from "../../../api"

const ChecklistBotones = ({ etapa, car_id, status }) => {
  const queryClient = useQueryClient()
  const [modalOpen, setModalOpen] = useState(false)

  // Mutación para cerrar el expediente contablemente
  const { mutateAsync: mutCerrarCarpeta, isPending: isClosing } = useMutation({
    mutationFn: async () => {
      return await api.post("/CRM_Carpetas/cerrarCarpeta", { car_id })
    },
    onSuccess: (res) => {
      showSuccess(res?.data?.data || "Expediente cerrado exitosamente.")
      queryClient.invalidateQueries(["getCarpetaWorkspace"])
    },
    onError: (err) => {
      showWarning(err?.response?.data?.message || "No se puede cerrar la carpeta por saldos pendientes.")
    },
  })

  const handleCerrar = () => {
    Swal.fire({
      title: "Auditoría de Cierre",
      text: "El sistema validará que todos los pedidos estén facturados y sin saldos pendientes. ¿Deseas continuar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#2E7D32",
      cancelButtonColor: "#d33",
      confirmButtonText: "Validar y Cerrar Venta",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await mutCerrarCarpeta()
      }
    })
  }

  if (status === "CERRADA") {
    return (
      <Paper elevation={3} sx={{ p: 3, borderRadius: 2, textAlign: "center", bgcolor: "#e8f5e9" }}>
        <DoneAllIcon color="success" sx={{ fontSize: 60, mb: 1 }} />
        <Typography variant="h6" color="success.main" fontWeight="bold">
          VENTA CERRADA
        </Typography>
        <Typography variant="body2" color="textSecondary">
          El ciclo de este expediente ha concluido.
        </Typography>
      </Paper>
    )
  }

  return (
    <>
      <Paper elevation={3} sx={{ p: 2, borderRadius: 2, height: "100%" }}>
        <Typography variant="subtitle1" fontWeight="bold" color="primary" mb={2}>
          Acciones Requeridas
        </Typography>

        <Box p={2} bgcolor="#f8f9fa" borderRadius={2} border="1px dashed #bdbdbd" mb={3}>
          <Typography variant="caption" color="textSecondary" display="block" mb={1}>
            PASO ACTUAL:
          </Typography>
          <Typography variant="body1" fontWeight="bold" color="textPrimary">
            {etapa.eta_nombre || "Sin etapa configurada"}
          </Typography>
        </Box>

        {etapa.eta_tipo === "MANUAL" && (
          <Button
            variant="contained"
            color="primary"
            fullWidth
            size="large"
            startIcon={<PlayCircleOutlineIcon />}
            onClick={() => setModalOpen(true)}
            sx={{ py: 1.5, fontWeight: "bold", borderRadius: 2 }}
          >
            Registrar Acción: {etapa.eta_nombre}
          </Button>
        )}

        {etapa.eta_tipo === "AUTOMATICO" && (
          <Box textAlign="center" p={2}>
            <AutoAwesomeIcon color="warning" sx={{ fontSize: 40, mb: 1 }} />
            <Typography variant="body2" color="textSecondary">
              Esta etapa es automática. El sistema avanzará solo cuando detecte el documento contable en el ERP (Ej:
              Factura o Pedido).
            </Typography>
          </Box>
        )}

        {etapa.eta_bloquea_cierre && (
          <>
            <Divider sx={{ my: 3 }} />
            <Button
              variant="outlined"
              color="secondary"
              fullWidth
              size="large"
              startIcon={<FactCheckIcon />}
              onClick={handleCerrar}
              disabled={isClosing}
              sx={{ py: 1.5, fontWeight: "bold", borderRadius: 2, borderWidth: 2 }}
            >
              Auditar y Cerrar Expediente
            </Button>
          </>
        )}
      </Paper>

      {/* Modal inyectado directamente para manejo simple de estado */}
      {modalOpen && (
        <ModalTareaBasica open={modalOpen} onClose={() => setModalOpen(false)} etapa={etapa} car_id={car_id} />
      )}
    </>
  )
}

export default ChecklistBotones
